/**
 * Reducer for the WAC failed tutorial. This triggers a tutorial the first time
 * a user fails a WAC and views the task item which had the incorrect WAC.
 * It only triggers once.
 */

import { fromJS } from 'immutable';
import log from 'loglevel';

import { WAC_INCORRECT, WAC_HAVENT_DONE_THIS } from 'phoenix2/state/wac/actions';
import { SET_TUTORIALS_COMPLETED, RESET_TUTORIALS } from '../actions';
import { MAKE_WAC_FAILED_TUTORIAL_INACTIVE } from '../tutorial-actions/wac-failed';

export const WAC_FAILED_TUTORIAL_KEY = 'wacFailedTutorial';

const INITIAL_STATE = fromJS({
    completed: false,

    // WAC failed tutorial waits for user to get a WAC wrong
    active: false,
    state: null,
});

export function wacFailedTutorialReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case RESET_TUTORIALS:
            return INITIAL_STATE;

        case SET_TUTORIALS_COMPLETED:
            if (action.tutorialIds.indexOf(WAC_FAILED_TUTORIAL_KEY) !== -1) {
                return fromJS({
                    completed: true,
                    active: false,
                    state: null,
                });
            }
            break;

        // Trigger WAC failed tutorial when student answers a question
        // incorrectly or they admit they didn't do their bookwork.
        case WAC_INCORRECT:
        case WAC_HAVENT_DONE_THIS:
            return triggerWacFailedTutorial(state, action);

        case MAKE_WAC_FAILED_TUTORIAL_INACTIVE:
            return fromJS({
                completed: state.get('completed'),
                active: false,
                state: null,
            });
    }

    return state;
}

/**
 * If the user has failed a WrittenAnswerCheck, activate the WAC failed
 * tutorial. Note, this is done even if the user has completed it before,
 * unlike some other tutorials
 * @param action the WAC_FAILED action
 * @param state the Redux state
 */
function triggerWacFailedTutorial(state, action) {
    // The WAC failed tutorial is only ever shown once, so
    // not triggered if complete
    const wacFailedTutorialComplete = state.get('completed');

    // On ground task item ID is null, on cloud it is the ID
    // of the question which has failed the WAC
    if (!wacFailedTutorialComplete && action.taskItemId) {
        log.debug('WAC failed tutorial triggered', action);
        return fromJS({
            completed: false,
            active: true,
            state: {
                taskItemId: action.taskItemId,
            },
        });
    }

    return state;
}
